import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GuestHashService {
  constructor() {}

  user;

  init() {
    this.getUser();
  }

  /**
   * Generate UUID v4
   */
  generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  makeid() {
    let result = '';
    let characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < 32; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  getUser() {
    if (!localStorage.getItem('user')) {
      this.user = { id: this.generateUUID(), username: '', lastSeen: Date.now() };
      this.saveUser();
      this.getUser();
    } else {
      this.user = JSON.parse(localStorage.getItem('user'));
      this.user.lastSeen = Date.now();
      if(!this.user.id) {
        this.user.id = this.generateUUID();
      }
      this.saveUser();
    }
    return this.user;
  }

  saveUser() {
    localStorage.setItem('user', JSON.stringify(this.user));
  }
}
